const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* === Footer menu: collapsible on mobile (ExpediCamp) === */
(function () {
  function initFooterAccordion() {
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var columns = document.querySelectorAll('.footer .footer-block--menu');
    columns.forEach(function (col) {
      var heading = col.querySelector('.footer-block__heading');
      var content = col.querySelector('.footer-block__details-content');
      if (!heading || !content || col.dataset.ecFooterInit) return;
      col.dataset.ecFooterInit = '1';
      col.classList.add('footer-block--collapsible');
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-expanded', 'false');
      function toggle() {
        if (!mqMobile.matches) return;
        var open = col.classList.toggle('is-open');
        heading.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      heading.addEventListener('click', toggle);
      heading.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
    if (mqMobile.addEventListener) {
      mqMobile.addEventListener('change', function () {
        if (mqMobile.matches) return;
        document.querySelectorAll('.footer .footer-block--collapsible.is-open').forEach(function (col) {
          col.classList.remove('is-open');
          var h = col.querySelector('.footer-block__heading');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }
})();
